import React from 'react';

import { bemCssModules } from '@utils';

import Preloader from '@components/Preloader';

import style from './ButtonOld.scss';

const cn = bemCssModules(style, 'ButtonOld');

export type TButtonOld = {
  className?: string;
  isLoading?: boolean;
  outline?: boolean;
  to?: string;
  href?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonOld: React.FC<TButtonOld> = ({
  className,
  children,
  isLoading = false,
  disabled = false,
  href,
  outline,
  to,
  type = 'button',
  ...rest
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      /* eslint-disable-next-line react/button-has-type */
      type={type}
      className={cn({ disabled: isDisabled, outline }, [className, 'button'])}
      disabled={isDisabled}
      {...rest}
    >
      <span className={cn('content', { isLoading })}>{children}</span>
      {isLoading && <Preloader className={cn('loader')} size={24} />}
    </button>
  );
};

export default ButtonOld;
